import { create } from "zustand";
import { sendOtp, verifyOtp } from "../../apiEndpoints/navutils";
import { getOrderToken } from "../../apiEndpoints/navutils";
import { verifyPayment } from "../../apiEndpoints/navutils";
export type CoupanItem = {
    id: number;
    title: string;
    description: string;
    price: string;
    fordays: number,
    coupanCode?: string | undefined
};

type OtpSignInState = {
    authed: boolean,
    showModal: boolean,
    otpValue: string,
    hideActivityIndicator: boolean,
    email: string;
    setEmail: (value: string) => void;
    toggleActivityIndicator: () => void;
    sendOtp: (taskCompleted: () => void) => void;
    coupans: CoupanItem[],
    openendCoupanCode: CoupanItem | undefined,
    handleBuy: (item: CoupanItem) => void;
    onOtpValueChange: (otp: string) => void,
    handleVefrifyOtp: () => void;
    loading: boolean,
    hideModal: () => void,
    openModal: () => void;
};

function getRazorpayKey(): string | null {
    const meta = document.querySelector('meta[name="razorpay-key"]');
    return meta ? meta.getAttribute("content") : null;
}

const loadRazorpay = () => {
    return new Promise((resolve) => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.onload = () => resolve(true);
        script.onerror = () => resolve(false);
        document.body.appendChild(script);
    });
};

export const useOtpSignIn = create<OtpSignInState>((set, get) => ({
    authed: false,
    showModal: false,
    loading: false,
    otpValue: "",
    openendCoupanCode: undefined,
    coupans: [],
    hideActivityIndicator: false,
    email: "",
    onOtpValueChange: (otp) => {
        set({ otpValue: otp })
    },
    setEmail: (value) => set({ email: value }),
    toggleActivityIndicator: () => {
        set((state) => ({
            hideActivityIndicator: !state.hideActivityIndicator,
        }))
    },
    sendOtp: async (taskCompleted) => {
        const { email } = get();
        set({ hideActivityIndicator: true })
        const result = await sendOtp(email);
        set({ hideActivityIndicator: false })
        if (result) {
            taskCompleted()
        }
    },
    handleBuy: async (item) => {

        const res = await loadRazorpay();

        if (!res) {
            alert("Razorpay SDK failed to load");
            return;
        }

        const { email } = get()
        set({ hideActivityIndicator: true });

        const order = await getOrderToken(item);
        const razorpaykey = getRazorpayKey();

        set({ hideActivityIndicator: false });

        const options = {
            key: razorpaykey,
            amount: order.amount,
            currency: order.currency,
            name: "Studyzem",
            description: item.title,
            order_id: order.id,

            handler: async (response: any) => {

                set({ hideActivityIndicator: true });


                try {

                    const result = await verifyPayment(response, item, email);
                    console.log("result");
                    console.log(result);

                    if (!result.success) {
                        alert(result.message);
                        set({ hideActivityIndicator: false });
                        return;
                    }

                    const { coupans } = get();

                    set({
                        hideActivityIndicator: false,
                        coupans: coupans.map((c) =>
                            c.id === item.id
                                ? { ...c, coupanCode: result.coupan_code }
                                : c
                        ),
                    });

                } catch (error) {

                    console.error(error);
                    set({ hideActivityIndicator: false });
                    alert("Server error during verification");

                }
            },

            modal: {
                ondismiss: function () {
                    alert("Payment cancelled by user.");
                },
            },

            theme: {
                color: "#1e90ff",
            },
        };

        const rzp = new window.Razorpay(options);
        rzp.open();
    },
    handleVefrifyOtp: async () => {
        const { email, otpValue } = get()
        set({ hideActivityIndicator: true })
        const result = await verifyOtp(email, otpValue)
        const items: CoupanItem[] = result
        set({ coupans: items });
        set({ hideActivityIndicator: false })
        set({ authed: true });
        set({ showModal: false })


    },
    hideModal: () => {
        set({ showModal: false })
    },
    openModal: () => {
        set({ showModal: true })
    }

}));
